import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import ListPaginationPayments from "../components/misc/ListPaginationPayments";


function DailyLoanRepaymentsDetailed() {
    return (
        <>
            <NavMain slug="daily-loan-repayments-detailed" parent="2" />
            <HeaderMain slug="daily-loan-repayments-detailed" />
            <div className="main-content">
                <ListPaginationPayments />
            </div>
        </>
    );
}

export default DailyLoanRepaymentsDetailed;